import { render, staticRenderFns } from "./recordSummary.vue?vue&type=template&id=64820958&scoped=true"
import script from "./recordSummary.vue?vue&type=script&lang=js"
export * from "./recordSummary.vue?vue&type=script&lang=js"
import style0 from "./recordSummary.vue?vue&type=style&index=0&id=64820958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64820958",
  null
  
)

export default component.exports